'use strict';

var FaresFilterByMonthFactory = function FaresFilterByMonthFactory(DataFilter) {
  function FaresFilterByMonth() {
    DataFilter.call(this, ['fares-chart-mode', 'fares-mode'], 'class-usage', 2);
  }
  FaresFilterByMonth.prototype = Object.create(DataFilter.prototype);
  FaresFilterByMonth.prototype.filter = function (data, range) {
    range = range[0];
    var months = range.months;
    return DataFilter.prototype.filter(data, months, 'month');
  };
  return FaresFilterByMonth;
};
FaresFilterByMonthFactory.$inject = ['DataFilterFactory'];
module.exports = FaresFilterByMonthFactory;